/**
 * It's possible that due to marketing blocks or special rules (e.g. ambassador products), the last row of products is not full, in this case, we need to add a special product tile that links to the next page
 * It could be different on desktop / mobile views
 * 
 * @returns {void}
 */
export default (nosto_nbHits, per_page) => {
    const productTilesGrid = document.querySelector('[data-product-tiles] .grid');
    if (!productTilesGrid || productTilesGrid.children.length === 0) {
        return;
    }

    // Remove any existing pagination tiles before calculating
    const existingTiles = productTilesGrid.querySelectorAll('.product-tile--pagination');
    existingTiles.forEach(tile => tile.remove());

    const total_pages = Math.ceil(nosto_nbHits / per_page);
    if (window.theme.collections.page >= total_pages) {
        return;
    }

    const lastChildBefore = productTilesGrid.lastElementChild;
    const lastTopBefore = lastChildBefore.offsetTop;

    const productTile = document.createElement('div');
    productTile.classList.add('product-tile', 'product-tile-pagination', 'product-tile--pagination', 'animate', 'animate--fade-in-up', 'column-xs-6', 'column-sm-4');
    productTile.innerHTML = `
    <button type="button" class="product-tile-pagination__link no-themed" data-pagination-next>
      <div class="product-tile-pagination__container">
        <h4 class="product-tile-pagination__title">Continue<br>Shopping</h4>

        <svg class="product-tile-pagination__arrow" xmlns="http://www.w3.org/2000/svg" width="81" height="21" viewBox="0 0 81 21" fill="none" aria-hidden="true">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M38.2324 10.4726C39.1881 13.0216 38.6572 14.4022 37.2766 16.1014C36.7458 16.6323 33.6656 19.1812 32.0727 18.3317C29.2052 16.8448 35.896 11.3224 38.2324 10.4729V10.4726ZM58.0915 5.05649C63.9325 5.05649 71.154 7.07426 76.4642 9.41062L78.482 10.3664L78.5882 10.4726C75.0836 11.1098 71.2603 12.2781 67.8622 13.2339C67.4374 13.4462 64.4638 13.9773 65.7382 14.9331C66.163 15.2516 72.4289 13.2339 73.3848 13.0216C74.6591 12.5967 80.5002 11.641 80.925 10.5789C80.925 8.77346 76.2523 5.48136 74.9777 4.31304C74.2343 3.67588 68.181 -0.572251 67.4375 0.0649086C66.8003 0.808362 67.6498 1.12694 68.2873 1.44552C72.4291 3.88817 74.6594 5.48106 78.0575 8.66716C76.6769 8.13629 75.19 7.49884 73.7034 6.96797C64.676 3.67588 56.2865 2.71984 47.0469 5.37507C42.0553 6.86198 41.6307 7.60543 38.6566 8.66716C35.5768 5.79964 32.9219 5.26878 28.0363 5.26878C19.646 5.37507 13.4866 8.1363 6.90209 12.1718C5.0966 13.2339 0.742485 17.0571 0.105324 19.0749C-0.31955 20.2432 0.636185 21.0927 1.27364 19.4998C1.69852 18.65 2.22939 18.0129 2.65427 17.482C3.71629 16.2077 4.99061 15.1456 6.37122 14.0836C12.4245 9.6232 18.5845 7.18056 26.549 6.5434C29.4165 6.33111 36.4257 6.86197 37.3814 9.41091C34.9388 10.7915 30.7969 13.765 30.2661 16.6326C30.0538 18.2255 30.7969 19.2875 31.9653 19.7124C34.1956 20.3495 42.1606 16.8448 39.2932 9.83564C40.5675 9.19848 41.8421 8.56132 43.3287 7.92416C48.1077 6.11867 52.6747 5.05664 58.0906 5.05664L58.0915 5.05649Z" fill="black"/>
        </svg>

        <p class="product-tile-pagination__text">go to the next page</p>
      </div>
    </button>
  `;
    productTilesGrid.appendChild(productTile);

    const addedChild = productTilesGrid.lastElementChild;

    // If the newly added tile wrapped to a new row, its offsetTop will be noticeably greater
    if (addedChild.offsetTop > lastTopBefore + 10) {
        productTilesGrid.removeChild(addedChild);
    }
};
